import { Injectable } from '@angular/core';
import { ConvertHelper } from '@barthauer/abc/core';
import { AssetsManagerService } from '..';

declare const pako: any;

@Injectable({
  providedIn: 'root',
})
export class CompressionService {
  constructor(private assets: AssetsManagerService) {}

  private async initialize(): Promise<void> {
    await this.assets.loadDependencies(['assets/compression/pako.min.js']);
  }

  public async gzipRaw(data: Uint8Array | ArrayBuffer | String | Object): Promise<Uint8Array> {
    await this.initialize();
    let rawdata = data;
    if (typeof data === 'object' && !(data instanceof ArrayBuffer) && !(data instanceof Uint8Array)) {
      rawdata = JSON.stringify(data);
    }
    return pako.gzip(rawdata);
  }

  public async gzipAsArrayBuffer(data: Uint8Array | ArrayBuffer | String | Object): Promise<ArrayBuffer> {
    const arr = await this.gzipRaw(data);
    return ConvertHelper.uint8ArrayToArrayBuffer(arr);
  }

  public async gzipJsonAsBase64<T>(value: T): Promise<string> {
    await this.initialize();
    return btoa(pako.gzip(new TextEncoder().encode(JSON.stringify(value))));
  }

  public async ungzipJsonFromBase64<T>(value: string): Promise<T> {
    await this.initialize();
    return JSON.parse(new TextDecoder().decode(pako.ungzip(new Uint8Array(JSON.parse('[' + atob(value) + ']')))));
  }
}
